// extracted by mini-css-extract-plugin
export default {"container":"switchBtn_container__IgUp8","title":"switchBtn_title__xtQj0","switch-label":"switchBtn_switch-label__1MIsT"};